import * as actionTypes from '../actions/actionTypes';

export default function (state = [], action) {
  switch (action.type) {
    case actionTypes.FETCH_INDUSTRIES_SUCCESS:
      return [...action.industries];
    default:
      return state;
  }
}
